// The fixed weekly plan shown on the home screen. Lifting days come from the
// routines' `weekday` (Mon Upper A, Tue Upper B, Thu Arms, Fri Legs); the gaps are
// Marko's non-lifting days (Wed rest/run/swim, weekend fun sports). The week is
// presentational only - "moving something" just means starting a different day's
// workout today, so nothing here persists a reschedule.

import type { Routine } from '../../domain/types';

export interface WeekDay {
  weekday: number; // 1 = Monday ... 7 = Sunday
  name: string; // 'Monday'
  short: string; // 'Mon'
  routine: Routine | null;
  restLabel: string | null; // shown on non-lifting days
  restSub: string | null;
}

const DAY_NAMES = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
const DAY_SHORT = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

// Non-lifting day labels for the days no routine maps to.
const REST_DAYS: Record<number, { label: string; sub: string }> = {
  3: { label: 'Rest / cardio', sub: 'Run or swim' },
  6: { label: 'Fun sports', sub: 'Weekend' },
  7: { label: 'Fun sports', sub: 'Weekend' },
};

export function buildWeek(routines: Routine[]): WeekDay[] {
  return [1, 2, 3, 4, 5, 6, 7].map((wd) => {
    const routine = routines.find((r) => r.weekday === wd) ?? null;
    const rest = REST_DAYS[wd];
    return {
      weekday: wd,
      name: DAY_NAMES[wd - 1],
      short: DAY_SHORT[wd - 1],
      routine,
      restLabel: routine ? null : rest?.label ?? 'Open day',
      restSub: routine ? null : rest?.sub ?? null,
    };
  });
}
